import { createReducer, on } from '@ngrx/store';
import { Department } from '@app/store/shared/models';
import { ROWS_PER_PAGE } from '@shared/components';
import { FormOption } from '@shared/forms';
import { departmentsActions } from '../actions/departments.actions';
import { GetDepartmentsValue } from '../models';

export interface DepartmentsState {
    loaded: boolean | null;
    loading: boolean;
    departments: Department[];
    value: GetDepartmentsValue;
    total: number;
    lookupLoaded: boolean | null;
    lookupLoading: boolean;
    lookup: FormOption<string>[];
}

export const initialState: DepartmentsState = {
    loaded: null,
    loading: false,
    departments: [],
    value: { page: 1, limit: ROWS_PER_PAGE[0], divisionIds: [] },
    total: 0,
    lookupLoaded: null,
    lookupLoading: false,
    lookup: [],
};

export const departmentsReducer = createReducer(
    initialState,
    // List
    on(departmentsActions.getDepartments, (state, { value }): DepartmentsState => ({
        ...state,
        value,
        loading: true,
    })),
    on(departmentsActions.getDepartmentsSuccess, (state, { payload }): DepartmentsState => ({
        ...state,
        loading: false,
        loaded: true,
        departments: payload.items,
        total: payload.total,
    })),
    on(departmentsActions.getDepartmentsError, (state): DepartmentsState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    // Lookup
    on(departmentsActions.getDepartmentsLookup, (state): DepartmentsState => ({
        ...state,
        lookupLoaded: state.lookupLoaded || null,
        lookupLoading: true,
    })),
    on(departmentsActions.getDepartmentsLookupSuccess, (state, { payload }): DepartmentsState => ({
        ...state,
        lookupLoaded: true,
        lookupLoading: false,
        lookup: payload,
    })),
    on(departmentsActions.getDepartmentsLookupError, (state): DepartmentsState => ({
        ...state,
        lookupLoaded: false,
        lookupLoading: false,
    })),
    // Clear
    on(departmentsActions.clear, (): DepartmentsState => ({
        ...initialState,
    })),
);
